module.exports = __webpack_public_path__ + "img/andco logo.386d669f.png";